// uploadLimits.js — client-side mirror of api/src/lib/uploadLimits.js.
//
// Kept in sync with the server rule so users get the error *before* anything is
// sent, rather than after a comment/case is already posted. The server remains
// the authority; this is purely UX.

export const MAX_ATTACHMENT_BYTES = 50 * 1024 * 1024; // 50 MB

const ALLOWED_EXTENSIONS = [
  'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'rtf',
  'jpg', 'jpeg', 'png', 'gif', 'heic', 'heif', 'webp', 'bmp', 'tiff',
  'mp4', 'mov', 'm4v',
];
const ALLOWED_SET = new Set(ALLOWED_EXTENSIONS);

// `accept` attribute value for the OS file picker (dot-prefixed extensions).
export const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map(e => `.${e}`).join(',');

/** Returns an error string if the upload is not allowed, or null if it's fine. */
export function validateUpload(fileName, byteLength) {
  if (!Number.isFinite(byteLength) || byteLength <= 0) {
    return 'File is empty.';
  }
  if (byteLength > MAX_ATTACHMENT_BYTES) {
    return `File exceeds the ${Math.round(MAX_ATTACHMENT_BYTES / 1024 / 1024)} MB limit.`;
  }
  const ext = (fileName.split('.').pop() || '').toLowerCase();
  if (!fileName.includes('.') || !ALLOWED_SET.has(ext)) {
    return `File type ".${ext}" is not allowed. Permitted: ${ALLOWED_EXTENSIONS.join(', ')}.`;
  }
  return null;
}
